import React from "react";
import i18n from '../../../../utils/ChrI18n';
import ChrTooltip from '../../../generic/Form/Basic/ChrTooltip';

const TopAreasOfConnection = ({ chartComponentData, nodeColors }) => {
  const { chart_data = [], choice_id_to_text_mapping } = chartComponentData;
  const topConnectedAreasData = chart_data.length > 0 ? [...chart_data].slice(0, 3) : [];
  const getNodeColor = (nodeName) => nodeColors[nodeName] || '#CCCCCC';
  const tooltipContent = i18n.t('widgets.silo_busting.top_areas_of_connection_tooltip', jsConstants.customTerms);

    return (
      <div className="cui-top-connections-container">
        <div className="d-flex align-items-center mb-2">
          <p className="font-600 mb-0"> 
            {i18n.t('widgets.silo_busting.top_areas_of_connection', jsConstants.customTerms)} 
          </p>
          <ChrTooltip
            content={ tooltipContent }
            iconClass="fa-regular fa-circle-info px-2"
            ariaLabel={ tooltipContent }
          />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-start flex-gap-15 mt-3">
          {topConnectedAreasData.map((item) => {
            const [answerChoiceID1, answerChoiceID2, connectionsCount] = item;
            const pairKey = `${answerChoiceID1}-${answerChoiceID2}`;     
            return (
              <div key={pairKey} className="d-flex flex-gap-10">
                <div className="bg-white font-14 align-center justify-center cui-connections-count-badge p-1">
                  {connectionsCount}
                </div>
                <div>
                  {[answerChoiceID1, answerChoiceID2].map((answerChoiceID) => {
                    const answerChoice = choice_id_to_text_mapping[answerChoiceID];
                    return (
                      <div key={`${pairKey}-${answerChoiceID}`} className="font-14 d-flex align-items-center">
                        <div className="mr-2 cui-node-color-indicator" style={{backgroundColor: getNodeColor(answerChoice)}}></div>
                        <span 
                          className="text-truncate cui-node-text-width" 
                          title={answerChoice}
                          data-toggle="tooltip" 
                          data-placement="top"
                        >
                          {answerChoice}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
}

export default TopAreasOfConnection;